import { FaRegUser } from "react-icons/fa";
import { defineField, defineType } from "sanity";

export default defineType({
  name: "personalArea",
  title: "Personal Area",
  type: "document",
  icon: FaRegUser,
  groups: [
    {
      name: "venetianSocietyContent",
      title: "Venetian Society Content"
    },
    {
      name: "exploreCruisesBanner",
      title: "Explore Cruises Banner Content"
    },
    {
      name: "royalOne",
      title: "Royal ONE"
    }
  ],
  fields: [
    defineField({
      name: "joinVsLink",
      title: "Join VS Link",
      type: "multilingualUrl",
      description: "Url for Join VS page",
      group: "venetianSocietyContent",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "goToVsLink",
      title: "Go to VS Link",
      type: "multilingualUrl",
      description: "Url for User's VS page",
      group: "venetianSocietyContent",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "vsMemberBenefitsLink",
      title: "VS Member Benefits Link",
      type: "multilingualUrl",
      group: "venetianSocietyContent",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "vsNotMemberLearnMoreLink",
      title: "VS Not Member Learn More Link",
      type: "multilingualUrl",
      group: "venetianSocietyContent",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "exploreCruisesBannerBackgroundImage",
      title: "Explore Cruises Banner Background Image",
      type: "image",
      options: { hotspot: true },
      group: "exploreCruisesBanner",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "exploreCruisesBannerTitle",
      title: "Explore Cruises Banner Title",
      type: "multilingualArrayString",
      group: "exploreCruisesBanner",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "exploreCruisesBannerDescription",
      title: "Explore Cruises Banner Description",
      type: "multilingualArrayBlockContent",
      group: "exploreCruisesBanner",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "exploreCruisesBannerCTA",
      title: "Explore Cruises Banner CTA",
      type: "ctaButtons",
      validation: (Rule) => Rule.max(1),
      group: "exploreCruisesBanner"
    }),
    defineField({
      name: "royalOneBannerImage",
      title: "Royal ONE Banner Image",
      description:
        "When the user doesn't have any credit cards, this banner will be shown",
      type: "image",
      options: { hotspot: true },
      group: "royalOne",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "royalOneBannerCompactImage",
      title: "Royal ONE Banner Compact Image",
      description:
        "Alternative image used when the banner takes up half of the drawer width. If not set, the Royal ONE Banner Image is used",
      type: "image",
      options: { hotspot: true },
      group: "royalOne"
    }),
    defineField({
      name: "royalOneBannerLink",
      title: "Royal ONE Banner Link",
      type: "multilingualUrl",
      group: "royalOne",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "royalOneCardsCTA",
      title: "Royal ONE Cards CTA",
      type: "ctaButtons",
      validation: (Rule) => Rule.max(1),
      group: "royalOne"
    })
  ],
  preview: {
    prepare(value) {
      return {
        title: "Personal Area"
      };
    }
  }
});
